export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-dispatch/index.js
// module id = 545
// module chunks = 0